// Adresses des pages piliers (contenu dans seo_pages.js, chargé à la demande).
export const SEO_PAGE_SLUGS = ["assurance-decennale", "devis-assurance-decennale", "decennale-auto-entrepreneur"];

// Pages fixes publiées dans le sitemap (hors fiches métiers, guides et pages piliers).
export const STATIC_ROUTES = [
  "/",
  "/metiers",
  "/prix",
  "/attestation",
  "/guide",
  "/sante",
  "/prevoyance",
  "/devis",
  "/contact",
  "/comparatif-assurance-decennale",
  "/a-propos",
  "/blog",
  "/cgu",
  "/confidentialite",
  "/mentions-legales",
  "/informations-reglementaires",
];
